import React from 'react'
import ReactDOM from 'react-dom'
import html2canvas from 'html2canvas'
import { connect } from 'react-redux'
import Route from '../../../../../lib/api/route'
import Elevation from '../../../../../lib/api/elevation'
import './index.scss'
import { blockFeatures, unBlockFeatures } from '../../../../../action/features-blocked-actions'
import { routeCreateRequest, routeUpdateRequest, routeDeleteRequest } from '../../../../../action/route-actions'
import { expandLeftToolbar } from '../../../../../action/left-toolbar-state-actions'
import { showSubscriptionModal } from '../../../../../action/show-subscription-modal-actions'
import { photoUploadRequest } from '../../../../../action/photo-actions'
import { TRACK_COLORS, TRACK_WIDTHS, trackPolylineOptions } from '../../../../../lib/trackColor'
import { trackCustom } from '../../../../../lib/tracking'
import { LINE_STYLES } from '../../common/track-details'
import StyleControls from '../../common/track-details/style-controls'
import { metersToDisplayDistance, distanceUnit, metersToElev, elevUnit, segmentDistanceMeters } from '../../../../../lib/trackStats'
import { userHasPro } from '../../../../../lib/util'
import {
  MAX_ROUTE_WAYPOINTS, DEFAULT_ROUTE_MODE, defaultFollows, isOffTrail, hasFullElevation, DEFAULT_ROUTE_COLOR, DEFAULT_ROUTE_LINE_STYLE,
  DEFAULT_ROUTE_WIDTH, routeLayers, layerMetersFromSteps, estimateRouteSeconds,
  formatRouteDuration, buildRouteProfile, pathDistanceMeters, elevationTotals, sampleIndices,
  applySampledElevations, straightLinePath, geometryToPath, bestInsertionIndex, waypointDistances,
  isDefaultRouteName, defaultRouteName, waypointLabel, waypointPinColor, buildRouteGeoJson, parseRouteGeoJson,
  START_PIN_COLOR, END_PIN_COLOR, MID_PIN_COLOR
} from '../../../../../lib/routeDocument'
import RouteProfile from './route-profile'

// Max path vertices sampled for the Elevation/Get request (same as mobile).
const PROFILE_SAMPLES = 120
// Minimum spacing between drag-preview route requests.
const DRAG_FETCH_MIN_INTERVAL_MS = 150
const SEARCH_DEBOUNCE_MS = 300
// Map thumbnail saved with the route: a square PNG from the centre of the map, taken
// once the framed route's tiles have settled (as the track and shape editors do).
const THUMB_PX = 350
const THUMB_SETTLE_MS = 1200
const SEARCH_MAX_ROWS = 6
const MODE_STORAGE_KEY = 'basemap.routeBuilder.mode'
const UPSELL_BODY = 'Pro plans routes that follow roads and trails, with elevation profiles, travel-time estimates and turn-by-turn navigation.'

// Route Prefers rows (saved as routeFollows). The router weights these networks rather than
// excluding the others, hence "prefers". Under Drive, Trails means motorized trails
// (API-3821); Off-trail is a Hike-only option (API-3822) for a cross-country path that
// still uses the ticked networks.
const FOLLOW_OPTS = [
  { key: 'main', label: 'Main roads', stroke: '#b8b8b8', strokeW: 3, dash: 'none', cap: 'round', under: 'rgba(0,0,0,0.55)', underW: 5 },
  { key: 'usfs', label: 'USFS roads', stroke: '#ffffff', strokeW: 3.4, dash: '8 8', cap: 'butt', under: '#000000', underW: 3.6 },
  { key: 'trails', label: 'Trails', driveLabel: 'Motorized trails', stroke: '#9ECC3B', strokeW: 2.6, dash: '6 5', cap: 'round', under: 'rgba(0,0,0,0.45)', underW: 4 },
  { key: 'offTrail', label: 'Off-trail', hikeOnly: true, stroke: '#c1c0c0', strokeW: 1.6, dash: '2 4', cap: 'round', under: 'rgba(0,0,0,0.45)', underW: 3 }
]
const followOn = (follows, key) => (key === 'offTrail' ? follows.offTrail === true : follows[key] !== false)

// Display text for the structured direction steps returned by Route/Get.
const LAYER_LABELS = {
  trail: 'the trail',
  usfs_road: 'the forest road',
  local_road: 'the local road',
  core_road: 'the road',
  usgs_road: 'the highway',
  connector: 'cross-country',
  cross_country: 'cross-country'
}
const TURN_LABELS = {
  straight: 'Continue straight',
  slight_left: 'Bear left',
  slight_right: 'Bear right',
  left: 'Turn left',
  right: 'Turn right',
  sharp_left: 'Sharp left',
  sharp_right: 'Sharp right'
}
const TURN_ICONS = {
  straight: 'M12 20V5M12 5l-5 5M12 5l5 5',
  slight_right: 'M8 20V12L16 5M16 5h-5M16 5v5',
  slight_left: 'M16 20V12L8 5M8 5h5M8 5v5',
  right: 'M5 20V10a3 3 0 0 1 3-3h9M17 7l-4-4M17 7l-4 4',
  left: 'M19 20V10a3 3 0 0 0-3-3H7M7 7l4-4M7 7l4 4',
  sharp_right: 'M6 20V13L17 8M17 8l-5-2M17 8l-2 5',
  sharp_left: 'M18 20V13L7 8M7 8l5-2M7 8l2 5'
}
const DEPART_ICON = 'M5 20V4l14 8-14 8Z'
const PIN_ICON = 'M12 21s7-6.3 7-11a7 7 0 1 0-14 0c0 4.7 7 11 7 11Z'
const COMPASS = ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW']
const compassDir = bearing => COMPASS[Math.round((((bearing % 360) + 360) % 360) / 45) % 8]

const pinSvg = (fill, stroke, strokeW, hole) =>
  '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="34" viewBox="0 0 26 34">' +
  `<path d="M13 33C11.5 30.5 3 20.5 3 13.2A10 10 0 0 1 23 13.2C23 20.5 14.5 30.5 13 33Z" fill="${fill}" stroke="${stroke}" stroke-width="${strokeW}"/>` +
  `<circle cx="13" cy="13" r="3.6" fill="${hole}"/></svg>`
const pinUrl = (fill, selected) => {
  const white = fill.toUpperCase() === '#FFFFFF'
  const svg = pinSvg(fill, selected ? '#9ECC3B' : white ? '#222222' : '#ffffff', selected ? 3 : 2, white ? '#444444' : 'rgba(0,0,0,0.45)')
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`
}
const pinCursor = fill => `url("${pinUrl(fill, false)}") 13 33, crosshair`

const num = n => Math.round(n || 0).toLocaleString('en-US')
const readStoredMode = () => {
  try { const m = window.localStorage.getItem(MODE_STORAGE_KEY); return m === 'hike' || m === 'drive' ? m : DEFAULT_ROUTE_MODE } catch (e) { return DEFAULT_ROUTE_MODE }
}
const storeMode = (m) => { try { window.localStorage.setItem(MODE_STORAGE_KEY, m) } catch (e) { /* private mode */ } }

const ProBadge = ({ style }) => <span className='rb-pro-badge' style={style}>PRO</span>
const Chevron = ({ open }) => (
  <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='#959595' strokeWidth='2.2' strokeLinecap='round' strokeLinejoin='round'
    style={{ transform: open ? 'rotate(180deg)' : 'none', transition: 'transform .2s' }}><path d='M6 9l6 6 6-6' /></svg>
)
const XIcon = ({ size = 15, onClick, color = '#959595' }) => (
  <svg onClick={onClick} width={size} height={size} viewBox='0 0 24 24' stroke={color} strokeWidth='2' style={{ cursor: 'pointer', flexShrink: 0 }}><path d='M4 4 20 20M20 4 4 20' /></svg>
)
const PinGlyph = ({ fill }) => (
  <svg width='16' height='21' viewBox='0 0 26 34' style={{ flexShrink: 0 }}>
    <path d='M13 33C11.5 30.5 3 20.5 3 13.2A10 10 0 0 1 23 13.2C23 20.5 14.5 30.5 13 33Z' fill={fill} stroke='rgba(0,0,0,0.55)' strokeWidth='1.5' />
    <circle cx='13' cy='13' r='3.6' fill='rgba(0,0,0,0.45)' />
  </svg>
)

/**
 * Route Builder (desktop). Screens, matching the mobile builders:
 *   build → SAVE → view;  view → EDIT ROUTE → edit → SAVE/CANCEL → view;  view → NAVIGATE → nav.
 * Opened from Map Tools it starts a new route (build); opened from a saved route on
 * the map (props.route) it starts on ROUTE DETAILS (view).
 */
class RouteBuilder extends React.Component {
  constructor(props) {
    super(props)
    const saved = props.route ? parseRouteGeoJson(props.route.geoJson) : null
    this.state = saved ? this.stateFromSaved(props.route, saved) : {
      screen: 'build',
      name: defaultRouteName((props.routes || []).length),
      notes: '',
      color: DEFAULT_ROUTE_COLOR,
      lineStyle: DEFAULT_ROUTE_LINE_STYLE,
      lineWidth: DEFAULT_ROUTE_WIDTH,
      mode: readStoredMode(),
      follows: defaultFollows(readStoredMode()),
      waypoints: [],
      coords: [],
      elevReady: false,
      distanceM: 0,
      steps: null,
      routedSeconds: null,
      layerMeters: null
    }
    Object.assign(this.state, {
      routing: false,
      routeMsg: null,
      arm: false,
      sel: null,
      undo: [],
      styleOpen: false,
      wpOpen: true,
      query: '',
      searchOpen: false,
      predictions: [],
      dialog: null,
      saving: false,
      saveError: null,
      navStep: 0,
      hoverIdx: null,
      overlayLeft: 0,
      toast: null
    })

    this.rootRef = React.createRef()
    this.overlayHost = null
    this.clickListener = null
    this.markers = []
    this.lines = { halo: null, main: null, arrows: null }
    this.hoverMarker = null
    this.navMarker = null
    this.routeSeq = 0
    this.elevSeq = 0
    this.dragFetchInFlight = false
    this.dragFetchQueued = false
    this.dragFetchTimer = null
    this.lastDragFetchAt = 0
    // Waypoints while a pin is mid-drag; kept off React state so dragging stays smooth.
    this.dragPoints = null
    this.searchTimer = null
    this.toastTimer = null
    this.featuresBlocked = false
    // Thumbnail photo id; replaced when a save captures a new thumbnail.
    this.photoId = props.route ? props.route.photoId : null

    this.measureOverlay = this.measureOverlay.bind(this)
    this.onKeyDown = this.onKeyDown.bind(this)
    this.undo = this.undo.bind(this)
    this.reverse = this.reverse.bind(this)
    this.clearAll = this.clearAll.bind(this)
    this.useMyLocation = this.useMyLocation.bind(this)
    this.goNav = this.goNav.bind(this)
    this.nextStep = this.nextStep.bind(this)
    this.save = this.save.bind(this)
    this.askCancelBuild = this.askCancelBuild.bind(this)
    this.close = this.close.bind(this)
    this.onClosePanel = this.onClosePanel.bind(this)
    this.goEdit = this.goEdit.bind(this)
    this.cancelEdit = this.cancelEdit.bind(this)
    this.doDelete = this.doDelete.bind(this)
    this.reverseSaved = this.reverseSaved.bind(this)
    this.upgrade = this.upgrade.bind(this)
  }

  stateFromSaved(route, doc) {
    const waypoints = doc.waypoints.length >= 2 ? doc.waypoints
      : doc.coords.length >= 2 ? [doc.coords[0], doc.coords[doc.coords.length - 1]].map(c => ({ lat: c[1], lng: c[0], name: '' })) : []
    const s = doc.stats || {}
    return {
      screen: 'view',
      name: route.name || '',
      notes: route.notes || '',
      color: doc.line.color,
      lineStyle: doc.line.style,
      lineWidth: doc.line.width,
      mode: doc.mode,
      follows: doc.follows,
      waypoints,
      coords: doc.coords,
      elevReady: doc.coords.some(c => c[2]),
      distanceM: s.distanceMeters || pathDistanceMeters(doc.coords),
      steps: doc.steps,
      routedSeconds: s.routedSeconds || null,
      layerMeters: s.layerMeters || null
    }
  }

  // ---------- lifecycle ----------

  // Route Builder is Pro, as on mobile: free users opening it get the upgrade gate,
  // and lapsed users can only view and delete their saved routes.
  isPro() { return userHasPro(this.props.user || {}) }
  gated() { return !this.props.route && !this.isPro() }

  upsell() {
    trackCustom('Upgrade', { 'Initiated From': 'Route Builder' })
    this.setState({ dialog: 'upsell' })
  }

  componentDidMount() {
    const { mapReference } = this.props
    if (!mapReference || typeof google === 'undefined' || this.gated()) return

    this.overlayHost = document.createElement('div')
    this.overlayHost.className = 'rb-overlay-host'
    mapReference.getDiv().appendChild(this.overlayHost)
    this.measureOverlay()
    window.addEventListener('resize', this.measureOverlay)
    if (typeof ResizeObserver !== 'undefined') {
      this.resizeObs = new ResizeObserver(this.measureOverlay)
      const panel = this.panelEl()
      if (panel) this.resizeObs.observe(panel)
    }

    this.clickListener = google.maps.event.addListener(mapReference, 'click', e => this.onMapClick(e))
    window.addEventListener('keydown', this.onKeyDown)

    this.syncScreenEffects()
    this.syncMarkers()
    if (this.state.coords.length >= 2) {
      this.drawPath(this.state.coords, true)
      if (!this.state.elevReady) this.fetchElevation(this.state.coords.map(c => [c[0], c[1]]), ++this.routeSeq)
    }
    this.forceUpdate() // render the portal now that the host exists
  }

  componentDidUpdate(prevProps, prevState) {
    const s = this.state
    if (prevState.waypoints !== s.waypoints || prevState.sel !== s.sel || prevState.screen !== s.screen) this.syncMarkers()
    if (prevState.color !== s.color || prevState.lineStyle !== s.lineStyle || prevState.lineWidth !== s.lineWidth) this.applyStyle()
    if (prevState.screen !== s.screen || prevState.arm !== s.arm || prevState.waypoints.length !== s.waypoints.length) this.syncScreenEffects()
    if (prevState.hoverIdx !== s.hoverIdx) this.syncHoverMarker()
    if (prevState.navStep !== s.navStep || prevState.screen !== s.screen || prevState.steps !== s.steps) this.syncNavMarker()
  }

  componentWillUnmount() {
    const { mapReference } = this.props
    if (this.clickListener) { this.clickListener.remove(); this.clickListener = null }
    window.removeEventListener('keydown', this.onKeyDown)
    window.removeEventListener('resize', this.measureOverlay)
    if (this.resizeObs) this.resizeObs.disconnect()
    clearTimeout(this.dragFetchTimer)
    clearTimeout(this.searchTimer)
    clearTimeout(this.toastTimer)
    this.routeSeq++ // drop any in-flight responses
    this.elevSeq++
    this.clearOverlays()
    if (this.overlayHost && this.overlayHost.parentNode) this.overlayHost.parentNode.removeChild(this.overlayHost)
    this.overlayHost = null
    if (this.featuresBlocked) this.props.unBlockFeatures()
    if (mapReference) mapReference.setOptions({ draggableCursor: 'grab' })
  }

  panelEl() {
    const root = this.rootRef.current
    return root ? (root.closest('.left-expanded-content-container') || root) : null
  }

  // Overlays on the map sit to the right of the left panel, which floats over the map.
  measureOverlay() {
    const { mapReference } = this.props
    const panel = this.panelEl()
    if (!mapReference || !panel) return
    const mapRect = mapReference.getDiv().getBoundingClientRect()
    const r = panel.getBoundingClientRect()
    const left = Math.max(0, Math.round(r.right - mapRect.left))
    if (left !== this.state.overlayLeft) this.setState({ overlayLeft: left })
  }

  // Block other map-object clicks while placing points, and set the map cursor.
  syncScreenEffects() {
    const { mapReference } = this.props
    const { screen, arm, waypoints } = this.state
    const editing = screen === 'build' || screen === 'edit'
    if (editing && !this.featuresBlocked) { this.props.blockFeatures(); this.featuresBlocked = true }
    if (!editing && this.featuresBlocked) { this.props.unBlockFeatures(); this.featuresBlocked = false }
    if (!mapReference) return
    let cursor = 'grab'
    // Armed: the cursor is the pin about to be placed (destination, start, waypoint).
    if (screen === 'build' && arm) cursor = pinCursor(waypoints.length === 0 ? END_PIN_COLOR : waypoints.length === 1 ? START_PIN_COLOR : MID_PIN_COLOR)
    if (screen === 'edit') cursor = 'crosshair'
    mapReference.setOptions({ draggableCursor: cursor })
  }

  onKeyDown(e) {
    if (e.key !== 'Escape') return
    if (this.state.dialog) this.setState({ dialog: null })
    else if (this.state.arm) this.setState({ arm: false })
  }

  // ---------- waypoints ----------

  editable() { return this.state.screen === 'build' || this.state.screen === 'edit' }

  pushUndo() {
    return this.state.screen === 'build' ? [...this.state.undo, this.state.waypoints] : this.state.undo
  }

  setWaypoints(waypoints, extra = {}) {
    this.setState({ waypoints, ...extra }, () => this.computeRoute())
  }

  onMapClick(e) {
    const { screen, arm } = this.state
    if (this.state.searchOpen) this.setState({ searchOpen: false })
    if (!this.editable()) return
    if (screen === 'build' && !arm) return
    this.addPoint({ lat: e.latLng.lat(), lng: e.latLng.lng(), name: '' })
  }

  // A lone pin is the destination; the second point becomes the start, and later
  // points go where they add the least distance (or extend either end).
  addPoint(p) {
    const wps = this.state.waypoints
    if (wps.length >= MAX_ROUTE_WAYPOINTS) {
      this.showToast(`Routes can have up to ${MAX_ROUTE_WAYPOINTS} waypoints.`)
      this.setState({ arm: false })
      return
    }
    let next
    let at
    if (wps.length === 0) { next = [p]; at = 0 } else if (wps.length === 1) { next = [p, wps[0]]; at = 0 } else {
      at = bestInsertionIndex(wps, p)
      next = wps.slice()
      next.splice(at, 0, p)
    }
    const name = this.state.name
    const extra = { undo: this.pushUndo(), arm: false, sel: this.state.screen === 'edit' ? at : null }
    // A searched destination names the route while it still has its default name.
    if (p.name && wps.length === 0 && isDefaultRouteName(name)) extra.name = `Route to ${p.name}`
    this.setWaypoints(next, extra)
  }

  removePoint(i) {
    const next = this.state.waypoints.slice()
    next.splice(i, 1)
    this.setWaypoints(next, { undo: this.pushUndo(), sel: null })
  }

  renamePoint(i, value) {
    const next = this.state.waypoints.slice()
    next[i] = { ...next[i], name: value }
    this.setState({ waypoints: next })
  }

  undo() {
    const undo = this.state.undo.slice()
    if (!undo.length) return
    const prev = undo.pop()
    this.setWaypoints(prev, { undo, sel: null })
  }

  reverse() {
    this.setWaypoints(this.state.waypoints.slice().reverse(), { undo: this.pushUndo(), sel: null })
  }

  clearAll() {
    this.setWaypoints([], { undo: this.pushUndo(), sel: null, arm: false })
  }

  useMyLocation() {
    if (!navigator.geolocation) { this.showToast('Location is not available in this browser.'); return }
    navigator.geolocation.getCurrentPosition(
      pos => this.addPoint({ lat: pos.coords.latitude, lng: pos.coords.longitude, name: 'My location' }),
      () => this.showToast('Couldn’t get your location. Click the map to place your start.'),
      { enableHighAccuracy: true, timeout: 10000 }
    )
  }

  selectPoint(i) {
    const sel = this.state.sel === i ? null : i
    this.setState({ sel })
    const p = this.state.waypoints[i]
    if (sel != null && p && this.props.mapReference) this.props.mapReference.panTo({ lat: p.lat, lng: p.lng })
  }

  // ---------- map markers ----------

  syncMarkers() {
    const { mapReference } = this.props
    if (!mapReference || typeof google === 'undefined') return
    this.markers.forEach(m => m.setMap(null))
    const { waypoints, sel } = this.state
    const draggable = this.editable()
    this.markers = waypoints.map((p, i) => {
      const fill = waypointPinColor(i, waypoints.length)
      const marker = new google.maps.Marker({
        map: mapReference,
        position: { lat: p.lat, lng: p.lng },
        icon: { url: pinUrl(fill, sel === i), scaledSize: new google.maps.Size(26, 34), anchor: new google.maps.Point(13, 33) },
        zIndex: sel === i ? 13 : 12,
        title: p.name || waypointLabel(i, waypoints.length),
        draggable,
        cursor: draggable ? 'grab' : 'default'
      })
      if (draggable) {
        marker.addListener('click', () => this.setState({ sel: this.state.sel === i ? null : i }))
        marker.addListener('dragstart', () => this.setState({ sel: i }))
        marker.addListener('drag', ev => this.onMarkerDrag(i, ev))
        marker.addListener('dragend', ev => this.onMarkerDragEnd(i, ev))
      }
      return marker
    })
  }

  // Live re-route while a pin is dragged: one request in flight and a minimum
  // interval, latest position wins; stale responses are dropped by routeSeq.
  onMarkerDrag(i, e) {
    const points = (this.dragPoints || this.state.waypoints).slice()
    points[i] = { ...points[i], lat: e.latLng.lat(), lng: e.latLng.lng() }
    this.dragPoints = points
    if (points.length >= 2) this.queueDragFetch()
  }

  onMarkerDragEnd(i, e) {
    const points = (this.dragPoints || this.state.waypoints).slice()
    points[i] = { ...points[i], lat: e.latLng.lat(), lng: e.latLng.lng() }
    this.dragPoints = null
    this.dragFetchQueued = false
    clearTimeout(this.dragFetchTimer)
    this.dragFetchTimer = null
    this.setWaypoints(points, { undo: this.pushUndo() })
  }

  queueDragFetch() {
    if (this.dragFetchInFlight) { this.dragFetchQueued = true; return }
    const sinceLast = Date.now() - this.lastDragFetchAt
    if (sinceLast < DRAG_FETCH_MIN_INTERVAL_MS) {
      if (!this.dragFetchTimer) {
        this.dragFetchTimer = setTimeout(() => { this.dragFetchTimer = null; this.queueDragFetch() }, DRAG_FETCH_MIN_INTERVAL_MS - sinceLast)
      }
      return
    }
    this.lastDragFetchAt = Date.now()
    this.dragFetchInFlight = true
    this.computeRoute({ lite: true }).then(() => {
      this.dragFetchInFlight = false
      if (this.dragFetchQueued) { this.dragFetchQueued = false; this.queueDragFetch() }
    })
  }

  // ---------- routing ----------

  // lite is the during-drag mode: quick routing, no directions, no elevation, silent
  // errors. Returns a promise that always resolves, for throttling.
  computeRoute({ lite = false } = {}) {
    const { token } = this.props
    const { mode, follows } = this.state
    const points = this.dragPoints || this.state.waypoints
    const seq = ++this.routeSeq

    if (points.length < 2) {
      this.clearLines()
      this.setState({ coords: [], distanceM: 0, steps: null, routedSeconds: null, layerMeters: null, elevReady: false, routing: false, routeMsg: null })
      return Promise.resolve()
    }

    const layers = routeLayers(mode, follows)
    const offTrail = isOffTrail(mode, follows)
    if (layers.length === 0) {
      if (!lite) this.useStraightLine(points, seq, null)
      else this.drawPath(straightLinePath(points), false)
      return Promise.resolve()
    }

    if (!lite) this.setState({ routing: true, routeMsg: null })
    return Route.getVia(points, token, { includeDirections: !lite, quick: lite, layers, mode, offTrail })
      .then(feature => {
        if (seq !== this.routeSeq) return
        const path = geometryToPath(feature && feature.geometry)
        if (path.length < 2) throw Object.assign(new Error('empty'), { status: 404 })
        this.drawPath(path, false)
        if (lite) return
        const props = (feature && feature.properties) || {}
        const steps = Array.isArray(props.steps) ? props.steps : null
        // Off-trail lines carry the terrain grid's elevation; then there's nothing to fetch.
        const withElev = hasFullElevation(path)
        this.setState({
          routing: false,
          routeMsg: null,
          coords: path.map(c => [c[0], c[1], withElev ? c[2] : 0]),
          elevReady: withElev,
          distanceM: props.distanceMeters || pathDistanceMeters(path),
          steps,
          routedSeconds: props.durationSeconds || null,
          layerMeters: layerMetersFromSteps(steps)
        })
        if (!withElev) this.fetchElevation(path, seq)
      })
      .catch(err => {
        if (seq !== this.routeSeq || lite) return
        // A 400 is something the user can fix (an off-trail leg too long, too many points):
        // say so and keep their points, rather than saving a straight line they didn't ask for.
        if (err && err.status === 400) { this.showRouteError(err); return }
        // Like iOS: fall back to straight lines and say why, so the route can still be saved.
        const msg = err && err.status === 404
          ? 'No route on the selected networks connects these points — showing straight lines.'
          : 'Couldn’t reach routing — showing straight lines.'
        this.useStraightLine(points, seq, msg)
      })
  }

  showRouteError(err) {
    const body = (err && err.response && err.response.body) || {}
    let msg = body.error_description || body.message || 'This route can’t be built as it is. Try moving or adding a waypoint.'
    if (body.error === 'leg_too_long' && Number.isInteger(body.leg)) {
      msg = `${this.legLabel(body.leg)} is too long for an off-trail path — add a stop or keep each leg within about 10 km.`
    }
    this.clearLines()
    this.setState({ routing: false, routeMsg: msg, coords: [], distanceM: 0, steps: null, routedSeconds: null, layerMeters: null, elevReady: false })
  }

  // "Start to Waypoint 2" for leg 0 of a route (legs are 0-based, as in the API).
  legLabel(leg) {
    const { waypoints } = this.state
    const name = i => (waypoints[i] && waypoints[i].name) || waypointLabel(i, waypoints.length)
    return `The leg from ${name(leg)} to ${name(leg + 1)}`
  }

  useStraightLine(points, seq, msg) {
    const path = straightLinePath(points)
    this.drawPath(path, false)
    this.setState({
      routing: false,
      routeMsg: msg,
      coords: path.map(c => [c[0], c[1], 0]),
      elevReady: false,
      distanceM: pathDistanceMeters(path),
      steps: null,
      routedSeconds: null,
      layerMeters: null
    })
    this.fetchElevation(path, seq)
  }

  fetchElevation(path, seq) {
    const { token } = this.props
    if (path.length < 2) return
    const eseq = ++this.elevSeq
    const idx = sampleIndices(path.length, PROFILE_SAMPLES)
    Elevation.getElevations(idx.map(i => ({ lat: path[i][1], lng: path[i][0] })), token)
      .then(elevations => {
        if (seq !== this.routeSeq || eseq !== this.elevSeq) return
        this.setState({ coords: applySampledElevations(path, idx, elevations || []), elevReady: true })
      })
      .catch(() => {
        if (seq !== this.routeSeq || eseq !== this.elevSeq) return
        this.setState({ elevReady: false })
      })
  }

  // Choosing a mode applies that mode's Route Prefers defaults (Hike: forest roads and
  // trails, no main roads, Off-trail off). A saved route opens with its own selection.
  setMode(mode) {
    if (mode === this.state.mode) return
    storeMode(mode)
    this.setState({ mode, follows: defaultFollows(mode) }, () => this.computeRoute())
  }

  toggleFollow(key) {
    const follows = { ...this.state.follows, [key]: !followOn(this.state.follows, key) }
    this.setState({ follows }, () => this.computeRoute())
  }

  // ---------- route line ----------

  drawPath(path, fit) {
    const { mapReference } = this.props
    if (!mapReference || typeof google === 'undefined') return
    const ll = path.map(c => new google.maps.LatLng(c[1], c[0]))
    if (!this.lines.main) {
      this.lines.halo = new google.maps.Polyline({ map: mapReference, zIndex: 9, clickable: false })
      this.lines.main = new google.maps.Polyline({ map: mapReference, zIndex: 10, clickable: false })
      this.lines.arrows = new google.maps.Polyline({ map: mapReference, zIndex: 11, clickable: false })
      this.applyStyle()
    }
    this.lines.halo.setPath(ll)
    this.lines.main.setPath(ll)
    this.lines.arrows.setPath(ll)
    if (fit && ll.length) {
      const b = new google.maps.LatLngBounds()
      ll.forEach(p => b.extend(p))
      mapReference.fitBounds(b, { top: 80, bottom: 60, right: 60, left: 60 + this.state.overlayLeft })
    }
  }

  applyStyle() {
    if (!this.lines.main || typeof google === 'undefined') return
    const { color, lineStyle, lineWidth } = this.state
    this.lines.main.setOptions(trackPolylineOptions(color, lineStyle, lineWidth))
    this.lines.halo.setOptions({ strokeColor: '#000000', strokeOpacity: 0.45, strokeWeight: lineWidth + 3, icons: [] })
    this.lines.arrows.setOptions({
      strokeOpacity: 0,
      icons: [{
        icon: { path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW, scale: 2.4, fillColor: color, fillOpacity: 1, strokeColor: '#000000', strokeWeight: 0.8, strokeOpacity: 1 },
        offset: '60px',
        repeat: '160px'
      }]
    })
  }

  clearLines() {
    Object.keys(this.lines).forEach(k => { if (this.lines[k]) this.lines[k].setMap(null); this.lines[k] = null })
  }

  clearOverlays() {
    this.markers.forEach(m => m.setMap(null))
    this.markers = []
    this.clearLines()
    if (this.hoverMarker) { this.hoverMarker.setMap(null); this.hoverMarker = null }
    if (this.navMarker) { this.navMarker.setMap(null); this.navMarker = null }
  }

  dotMarker(existing, position, fill, scale, zIndex) {
    if (existing) { existing.setPosition(position); return existing }
    return new google.maps.Marker({
      map: this.props.mapReference,
      position,
      clickable: false,
      zIndex,
      icon: { path: google.maps.SymbolPath.CIRCLE, scale, fillColor: fill, fillOpacity: 1, strokeColor: '#ffffff', strokeWeight: 2.5 }
    })
  }

  syncHoverMarker() {
    const { hoverIdx, coords, color } = this.state
    if (hoverIdx == null || !coords[hoverIdx] || typeof google === 'undefined') {
      if (this.hoverMarker) { this.hoverMarker.setMap(null); this.hoverMarker = null }
      return
    }
    const c = coords[hoverIdx]
    this.hoverMarker = this.dotMarker(this.hoverMarker, { lat: c[1], lng: c[0] }, color, 6, 14)
  }

  // ---------- navigation ----------

  navSteps() {
    const { steps, waypoints, coords } = this.state
    if (steps && steps.length) return steps
    // Straight-line routes have no router steps: depart, each waypoint, arrive.
    const d = waypointDistances(waypoints, coords)
    return waypoints.map((p, i) => ({
      type: i === 0 ? 'depart' : i === waypoints.length - 1 ? 'arrive' : 'waypoint',
      waypointNumber: i + 1,
      distanceMeters: i < waypoints.length - 1 ? d[i + 1] - d[i] : 0,
      layer: 'connector'
    }))
  }

  navStartMeters(steps, i) {
    const total = this.totalMeters()
    const stepSum = steps.reduce((a, s) => a + (s.distanceMeters || 0), 0) || 1
    let d = 0
    for (let k = 0; k < i; k++) d += steps[k].distanceMeters || 0
    return Math.min(total, d * total / stepSum)
  }

  pointAtMeters(target) {
    const { coords } = this.state
    if (!coords.length) return null
    let cum = 0
    for (let i = 1; i < coords.length; i++) {
      const seg = segmentDistanceMeters(coords[i - 1], coords[i])
      if (cum + seg >= target) {
        const t = seg > 0 ? (target - cum) / seg : 0
        return { lat: coords[i - 1][1] + (coords[i][1] - coords[i - 1][1]) * t, lng: coords[i - 1][0] + (coords[i][0] - coords[i - 1][0]) * t }
      }
      cum += seg
    }
    const last = coords[coords.length - 1]
    return { lat: last[1], lng: last[0] }
  }

  syncNavMarker() {
    if (this.state.screen !== 'nav' || typeof google === 'undefined') {
      if (this.navMarker) { this.navMarker.setMap(null); this.navMarker = null }
      return
    }
    const steps = this.navSteps()
    const p = this.pointAtMeters(this.navStartMeters(steps, Math.min(this.state.navStep, steps.length - 1)))
    if (!p) return
    this.navMarker = this.dotMarker(this.navMarker, p, '#9ECC3B', 8, 15)
    this.props.mapReference.panTo(p)
  }

  goNav() {
    if (!this.isPro()) { this.upsell(); return }
    this.setState({ screen: 'nav', navStep: 0, sel: null })
    // Saved routes from older clients may lack steps: fetch them (iOS does the same).
    const { mode, follows } = this.state
    const layers = routeLayers(mode, follows)
    if (!this.state.steps && layers.length > 0 && this.state.waypoints.length >= 2) {
      const seq = this.routeSeq
      Route.getVia(this.state.waypoints, this.props.token, { includeDirections: true, layers, mode, offTrail: isOffTrail(mode, follows) })
        .then(f => { if (seq === this.routeSeq && f && f.properties && Array.isArray(f.properties.steps)) this.setState({ steps: f.properties.steps }) })
        .catch(() => { /* keep the waypoint steps */ })
    }
  }

  nextStep() {
    const last = this.navSteps().length - 1
    if (this.state.navStep >= last) this.setState({ screen: 'view', navStep: 0 })
    else this.setState({ navStep: this.state.navStep + 1 })
  }

  stepText(step) {
    const name = step.name || LAYER_LABELS[step.layer] || 'the path'
    // Cross-country stretches have no way to turn "onto".
    const xc = step.layer === 'cross_country' && !step.name
    switch (step.type) {
      case 'depart':
        if (step.bearing == null) return `Start at ${this.state.name || 'route'}`
        return xc ? `Head ${compassDir(step.bearing)} cross-country` : `Head ${compassDir(step.bearing)} on ${name}`
      case 'turn': return xc ? `${TURN_LABELS[step.direction] || 'Continue'} and go cross-country` : `${TURN_LABELS[step.direction] || 'Continue'} onto ${name}`
      case 'waypoint': return `Arrive at ${this.waypointName(step.waypointNumber - 1)}`
      case 'arrive': return `Arrive at ${this.waypointName(this.state.waypoints.length - 1)}`
      default: return name
    }
  }

  waypointName(i) {
    const p = this.state.waypoints[i]
    if (p && p.name) return p.name
    return i === this.state.waypoints.length - 1 ? 'destination' : `waypoint ${i + 1}`
  }

  stepIcon(step) {
    if (step.type === 'depart') return DEPART_ICON
    if (step.type === 'waypoint' || step.type === 'arrive') return PIN_ICON
    return TURN_ICONS[step.direction] || TURN_ICONS.straight
  }

  // ---------- search ----------

  onQuery(query) {
    this.setState({ query, searchOpen: true })
    clearTimeout(this.searchTimer)
    if (query.trim().length < 2 || typeof google === 'undefined' || !google.maps.places) {
      this.setState({ predictions: [] })
      return
    }
    this.searchTimer = setTimeout(() => {
      const { mapReference } = this.props
      if (!this.autocomplete) this.autocomplete = new google.maps.places.AutocompleteService()
      const center = mapReference && mapReference.getCenter()
      const bounds = mapReference && mapReference.getBounds()
      const q = query
      this.autocomplete.getPlacePredictions({ input: q, ...(center ? { origin: center } : {}), ...(bounds ? { locationBias: bounds } : {}) }, (preds) => {
        if (this.state.query !== q) return
        this.setState({ predictions: (preds || []).slice(0, SEARCH_MAX_ROWS) })
      })
    }, SEARCH_DEBOUNCE_MS)
  }

  pickPlace(pred) {
    const { mapReference } = this.props
    if (!mapReference || this.resolvingPlace) return
    this.resolvingPlace = true
    if (!this.placesService) this.placesService = new google.maps.places.PlacesService(mapReference)
    const name = (pred.structured_formatting && pred.structured_formatting.main_text) || (pred.description || '').split(',')[0]
    this.placesService.getDetails({ placeId: pred.place_id, fields: ['geometry', 'name'] }, (place, status) => {
      this.resolvingPlace = false
      if (status !== google.maps.places.PlacesServiceStatus.OK || !place || !place.geometry) {
        this.showToast('Couldn’t find that place. Try another search.')
        return
      }
      const loc = place.geometry.location
      this.setState({ query: '', searchOpen: false, predictions: [] })
      mapReference.panTo(loc)
      if (this.state.waypoints.length === 0) mapReference.setZoom(Math.max(mapReference.getZoom() || 0, 14))
      this.addPoint({ lat: loc.lat(), lng: loc.lng(), name })
    })
  }

  // ---------- style ----------


  // ---------- stats ----------

  totalMeters() {
    return this.state.distanceM || pathDistanceMeters(this.state.coords)
  }

  stats() {
    const { coords, elevReady, mode, layerMeters, routedSeconds } = this.state
    const distanceMeters = this.totalMeters()
    const t = elevReady ? elevationTotals(coords) : { gain: 0, loss: 0, max: 0 }
    return {
      distanceMeters,
      gainMeters: t.gain,
      lossMeters: t.loss,
      maxMeters: t.max,
      layerMeters,
      routedSeconds,
      estimatedSeconds: estimateRouteSeconds({ distanceMeters, gainMeters: t.gain, mode, layerMeters, routedSeconds, offTrail: isOffTrail(mode, this.state.follows) })
    }
  }

  // ---------- save / edit / delete ----------

  payload() {
    const { name, notes, color, lineStyle, lineWidth, mode, follows, waypoints, coords, steps } = this.state
    const geoJson = buildRouteGeoJson({
      coords, waypoints, mode, follows, steps,
      line: { color, style: lineStyle, width: lineWidth },
      stats: this.stats()
    })
    const base = { name: name.trim() || defaultRouteName((this.props.routes || []).length), notes, userId: this.props.user.id, geoJson }
    const r = this.props.route
    const withPhoto = this.photoId ? { ...base, photoId: this.photoId } : base
    return r ? { ...withPhoto, id: r.id, public: r.public ?? false } : withPhoto
  }

  canSave() {
    const { waypoints, routing, saving, coords } = this.state
    return waypoints.length >= 2 && coords.length >= 2 && !routing && !saving
  }

  // A new thumbnail when the route is new, has none yet, or its line or style changed.
  needsThumbnail() {
    const b = this.backup
    const s = this.state
    return !this.props.route || !this.photoId || !b ||
      b.coords !== s.coords || b.color !== s.color || b.lineStyle !== s.lineStyle || b.lineWidth !== s.lineWidth
  }

  // Frame the route inside the centre crop with the builder's overlays hidden, capture,
  // upload as a map-screenshot photo, restore the view. Resolves the photo id, or null.
  captureThumbnail() {
    const { mapReference, photoUploadRequest } = this.props
    const { coords } = this.state
    if (!mapReference || typeof google === 'undefined' || coords.length < 2) return Promise.resolve(null)
    const el = mapReference.getDiv()
    const rect = el.getBoundingClientRect()
    const view = { center: mapReference.getCenter(), zoom: mapReference.getZoom() }
    const padX = Math.max(10, (rect.width - THUMB_PX) / 2 + 24)
    const padY = Math.max(10, (rect.height - THUMB_PX) / 2 + 24)
    const bounds = new google.maps.LatLngBounds()
    coords.forEach(c => bounds.extend({ lat: c[1], lng: c[0] }))
    if (this.overlayHost) this.overlayHost.style.visibility = 'hidden'
    this.setState({ hoverIdx: null, sel: null })
    mapReference.fitBounds(bounds, { top: padY, bottom: padY, left: padX, right: padX })

    const restore = () => {
      if (this.overlayHost) this.overlayHost.style.visibility = ''
      if (view.center) { mapReference.setCenter(view.center); mapReference.setZoom(view.zoom) }
    }
    return new Promise(resolve => setTimeout(resolve, THUMB_SETTLE_MS))
      .then(() => html2canvas(el, { useCORS: true }))
      .then(canvas => {
        // html2canvas renders at devicePixelRatio; crop the centre square in canvas pixels.
        const k = canvas.width / rect.width
        const crop = document.createElement('canvas')
        crop.width = THUMB_PX
        crop.height = THUMB_PX
        crop.getContext('2d').drawImage(canvas,
          Math.max(0, (rect.width - THUMB_PX) / 2) * k, Math.max(0, (rect.height - THUMB_PX) / 2) * k,
          THUMB_PX * k, THUMB_PX * k, 0, 0, THUMB_PX, THUMB_PX)
        restore()
        return new Promise((resolve, reject) => crop.toBlob(b => (b ? resolve(b) : reject(new Error('thumbnail blob failed'))), 'image/png'))
      })
      .then(blob => {
        const data = new FormData()
        data.append('photo', blob)
        data.append('photoInfo', JSON.stringify({ typeId: 4, name: 'map-screenshot' }))
        return photoUploadRequest(data)
      })
      .then(res => (res && res.id ? res.id : null))
      .catch(err => {
        restore()
        console.warn('Route thumbnail capture failed', err)
        return null
      })
  }

  // opts.thumbnail: false skips the thumbnail (Reverse on ROUTE DETAILS keeps the same line).
  save(opts) {
    if (!this.canSave()) return
    const { route, routeCreateRequest, routeUpdateRequest, expandLeftToolbar } = this.props
    const thumbnail = !(opts && opts.thumbnail === false) && this.needsThumbnail()
    this.setState({ saving: true, saveError: null, dialog: null })
    const shot = thumbnail ? this.captureThumbnail() : Promise.resolve(null)
    shot.then(photoId => {
      if (photoId) this.photoId = photoId
      return route ? routeUpdateRequest(this.payload()) : routeCreateRequest(this.payload())
    }).then(saved => {
      this.setState({ saving: false })
      if (!route) {
        if (typeof window.gtag === 'function') window.gtag('event', 'create_route', { waypoint_count: this.state.waypoints.length })
        // Reopen as the saved record so later edits update it in place.
        expandLeftToolbar({ dialog: 'edit', editable: { ...saved, measureType: 'route' } })
      } else {
        this.backup = null
        this.setState({ screen: 'view', sel: null, arm: false })
      }
    }).catch(() => {
      this.setState({ saving: false, saveError: 'Couldn’t save your route. Check your connection and try again.' })
    })
  }

  askCancelBuild() {
    const n = this.state.waypoints.length
    if (n === 0) { this.close(); return }
    this.setState({ dialog: n >= 2 ? 'save' : 'discard' })
  }

  close() {
    if (this.props.onClose) this.props.onClose()
  }

  onClosePanel() {
    const { screen } = this.state
    if (screen === 'build') this.askCancelBuild()
    else if (screen === 'edit') { this.cancelEdit(); this.close() } else this.close()
  }

  // ROUTE DETAILS Reverse (mobile): flip the route and save it in place, no re-route.
  reverseSaved() {
    if (!this.isPro()) { this.upsell(); return }
    if (this.state.saving) return
    const s = this.state
    const coords = s.coords.slice().reverse()
    this.setState({ waypoints: s.waypoints.slice().reverse(), coords, steps: null }, () => {
      this.drawPath(coords, false)
      this.save({ thumbnail: false })
    })
  }

  goEdit() {
    if (!this.isPro()) { this.upsell(); return }
    const s = this.state
    this.backup = { name: s.name, notes: s.notes, color: s.color, lineStyle: s.lineStyle, lineWidth: s.lineWidth, mode: s.mode, follows: s.follows, waypoints: s.waypoints, coords: s.coords, elevReady: s.elevReady, distanceM: s.distanceM, steps: s.steps, routedSeconds: s.routedSeconds, layerMeters: s.layerMeters }
    this.setState({ screen: 'edit', sel: null, styleOpen: false, undo: [] })
  }

  cancelEdit() {
    const b = this.backup
    this.backup = null
    this.routeSeq++
    if (!b) { this.setState({ screen: 'view', sel: null }); return }
    this.setState({ ...b, screen: 'view', sel: null, routing: false, routeMsg: null, saveError: null }, () => {
      if (b.coords.length >= 2) this.drawPath(b.coords, false)
      else this.clearLines()
    })
  }

  doDelete() {
    const { route, routeDeleteRequest } = this.props
    if (!route) return
    this.setState({ saving: true })
    routeDeleteRequest(route.id)
      .then(() => this.close())
      .catch(() => this.setState({ saving: false, dialog: null, saveError: 'Couldn’t delete this route. Please try again.' }))
  }

  showToast(text) {
    clearTimeout(this.toastTimer)
    this.setState({ toast: text })
    this.toastTimer = setTimeout(() => this.setState({ toast: null }), 3500)
  }

  // ---------- render helpers ----------

  dist(m) { return metersToDisplayDistance(m, this.props.units).toFixed(2) }
  elev(m) { return num(metersToElev(m, this.props.units)) }

  renderStyleCard() {
    const { styleOpen, color, lineStyle, lineWidth } = this.state
    const rollDash = { solid: 'none', dots: '0.1 20', dashed: '22 14' }[lineStyle]
    return (
      <div className='rb-card rb-collapsible'>
        <div className='rb-card-head' onClick={() => this.setState({ styleOpen: !styleOpen })}>
          <span className='rb-card-title'>Style</span>
          <div className='rb-card-head-right'>
            <svg width='64' height='9' viewBox='0 0 64 9'>
              <line x1='1' y1='4.5' x2='63' y2='4.5' pathLength='100' stroke={color} strokeWidth='3' strokeLinecap={lineStyle === 'dots' ? 'round' : 'butt'} strokeDasharray={rollDash} />
            </svg>
            <Chevron open={styleOpen} />
          </div>
        </div>
        {styleOpen && (
          <div className='rb-card-body track-details-root'>
            <StyleControls
              colors={TRACK_COLORS} color={color} onColor={c => this.setState({ color: c })}
              lineStyles={LINE_STYLES} lineStyle={lineStyle} onLineStyle={v => this.setState({ lineStyle: v })}
              widths={TRACK_WIDTHS} lineWidth={lineWidth} onWidth={w => this.setState({ lineWidth: w })}
              isPro
            />
          </div>
        )}
      </div>
    )
  }

  renderTravel() {
    const { mode } = this.state
    return (
      <div className='rb-travel'>
        {[['drive', 'Drive'], ['hike', 'Hike']].map(([m, label]) => (
          <div key={m} className={`rb-travel-opt${mode === m ? ' rb-on' : ''}`} onClick={() => this.setMode(m)}>{label}</div>
        ))}
      </div>
    )
  }

  renderWaypointRows(dists, alwaysShowDelete) {
    const { waypoints, sel } = this.state
    const n = waypoints.length
    return waypoints.map((p, i) => (
      <div key={i} className='rb-wp-row' style={{ background: sel === i ? 'rgba(88,149,0,0.14)' : 'transparent' }} onClick={() => this.selectPoint(i)}>
        <PinGlyph fill={waypointPinColor(i, n)} />
        <input className='rb-wp-name' value={p.name || ''} placeholder={waypointLabel(i, n)}
          onClick={e => e.stopPropagation()}
          onFocus={() => this.setState({ sel: i })}
          onChange={e => this.renamePoint(i, e.target.value)}
          onKeyDown={e => { if (e.key === 'Enter' || e.key === 'Escape') e.target.blur() }} />
        <span className='rb-wp-dist'>{this.dist(dists[i] || 0)} {distanceUnit(this.props.units)}</span>
        {(alwaysShowDelete || sel === i) && (
          <svg onClick={e => { e.stopPropagation(); this.removePoint(i) }} width='15' height='15' viewBox='0 0 24 24' fill='none' stroke='#959595'
            strokeWidth='1.8' strokeLinecap='round' style={{ cursor: 'pointer', flexShrink: 0, opacity: sel === i ? 1 : 0.55 }}>
            <path d='M4 7h16M9 7V5h6v2M6 7l1 13h10l1-13' />
          </svg>
        )}
      </div>
    ))
  }

  renderBuildPanel(profile, dists) {
    const { name, notes, waypoints, wpOpen } = this.state
    const n = waypoints.length
    return (
      <>
        <input className='rb-field' value={name} onChange={e => this.setState({ name: e.target.value })} placeholder='Route name' />
        {n < 2 && (
          <div className='rb-hint'>
            {n === 0 ? 'Add a destination to start. Search for a place or click ADD DESTINATION, then click the map.' : 'Now add your starting point.'}
          </div>
        )}
        {this.renderTravel()}
        {this.renderStyleCard()}
        {n > 0 && (
          <div className='rb-card rb-collapsible'>
            <div className='rb-card-head' onClick={() => this.setState({ wpOpen: !wpOpen })}>
              <span className='rb-card-title'>Waypoints</span>
              <div className='rb-card-head-right'>
                <span className='rb-count'>{n}</span>
                <Chevron open={wpOpen} />
              </div>
            </div>
            {wpOpen && (
              <div className='rb-wp-list'>
                {this.renderWaypointRows(dists, true)}
                <div className='rb-wp-actions'>
                  {n > 1 && <span onClick={this.reverse}>Reverse</span>}
                  {n > 3 && <span onClick={this.clearAll}>Clear all</span>}
                </div>
              </div>
            )}
          </div>
        )}
        {this.renderCompactProfile(profile, dists)}
        <textarea className='rb-notes' placeholder='Add notes' value={notes} onChange={e => this.setState({ notes: e.target.value })} />
      </>
    )
  }

  renderEditPanel(profile, dists) {
    const { name, notes, sel } = this.state
    return (
      <>
        <input className='rb-field' value={name} onChange={e => this.setState({ name: e.target.value })} placeholder='Route name' />
        {this.renderTravel()}
        {this.renderStyleCard()}
        <div className='rb-card rb-wp-card'>
          <div className='rb-wp-card-head'>
            <span className='rb-eyebrow'>WAYPOINTS</span>
            {this.state.waypoints.length > 1 && <span className='rb-link' onClick={this.reverse}>Reverse</span>}
          </div>
          <div className='rb-wp-list rb-wp-list-fill'>{this.renderWaypointRows(dists, false)}</div>
          <span className='rb-wp-hint'>
            {sel == null ? 'Select a waypoint to rename or remove it · click the map to add one' : 'Drag the selected waypoint on the map to move it'}
          </span>
        </div>
        {this.renderCompactProfile(profile, dists)}
        <textarea className='rb-notes' placeholder='Add notes' value={notes} onChange={e => this.setState({ notes: e.target.value })} />
      </>
    )
  }

  renderCompactProfile(profile, dists) {
    const { waypoints, elevReady, color } = this.state
    if (waypoints.length < 2) return null
    if (!elevReady) return <div className='rb-card rb-prof-loading'>Loading elevation…</div>
    return <RouteProfile compact profile={profile} waypointDists={dists} units={this.props.units} color={color} onHover={i => this.setState({ hoverIdx: i })} />
  }

  renderViewPanel(profile, dists, st) {
    const { name, notes, waypoints, mode, elevReady, color } = this.state
    const { route, units } = this.props
    const when = route && (route.created || route.updated)
    const date = new Intl.DateTimeFormat('en-US', { month: 'long', day: 'numeric', year: 'numeric' }).format(when ? new Date(when) : new Date())
    return (
      <>
        <div className='rb-view-name'>{name}</div>
        <div className='rb-view-sub'>
          {date} · {waypoints.length} waypoints · {mode === 'hike' ? (isOffTrail(mode, this.state.follows) ? 'Hike · Off-trail' : 'Hike') : 'Drive'}
          <span className='rb-link rb-view-reverse' onClick={this.reverseSaved}>Reverse</span>
        </div>
        <div className='rb-tiles'>
          <div className='rb-tile'><div className='rb-tile-val'>{this.dist(st.distanceMeters)}<span>{distanceUnit(units)}</span></div><div className='rb-label'>Distance</div></div>
          <div className='rb-tile'><div className='rb-tile-val'>{formatRouteDuration(st.estimatedSeconds)}</div><div className='rb-label'>Est Time</div></div>
        </div>
        <div className='rb-smallstats'>
          <div><div className='rb-label'>Elev Gain</div><div className='rb-smallval rb-green'>+{this.elev(st.gainMeters)} <span>{elevUnit(units)}</span></div></div>
          <div><div className='rb-label'>Elev Loss</div><div className='rb-smallval rb-grey'>-{this.elev(st.lossMeters)} <span>{elevUnit(units)}</span></div></div>
          <div><div className='rb-label'>Max Elev</div><div className='rb-smallval'>{this.elev(st.maxMeters)} <span>{elevUnit(units)}</span></div></div>
        </div>
        {elevReady
          ? <RouteProfile profile={profile} waypointDists={dists} units={units} color={color} onHover={i => this.setState({ hoverIdx: i })} />
          : <div className='rb-prof-loading'>Loading elevation…</div>}
        {notes ? <div className='rb-view-notes'>{notes}</div> : null}
      </>
    )
  }

  renderNavPanel(st) {
    const { name, navStep } = this.state
    const { units } = this.props
    const steps = this.navSteps()
    const cur = Math.min(navStep, steps.length - 1)
    const total = st.distanceMeters || 1
    const start = this.navStartMeters(steps, cur)
    const remain = Math.max(0, total - start)
    // Gain still ahead from the current step's start.
    const ahead = elevationTotals(this.coordsAfter(start)).gain
    return (
      <>
        <div className='rb-nav-name'>{name}</div>
        <div className='rb-nav-stats'>
          <div><span className='rb-nav-val'>{this.dist(remain)}<small>{distanceUnit(units)}</small></span><span className='rb-label'>Remaining</span></div>
          <div><span className='rb-nav-val'>{formatRouteDuration(st.estimatedSeconds * remain / total)}</span><span className='rb-label'>Time left</span></div>
          <div><span className='rb-nav-val rb-green'>+{this.elev(ahead)}<small>{elevUnit(units)}</small></span><span className='rb-label'>Gain ahead</span></div>
        </div>
        <div className='rb-steps'>
          {steps.map((s, i) => (
            <div key={i} className={`rb-step${i === cur ? ' rb-step-cur' : ''}`} onClick={() => this.setState({ navStep: i })}>
              <svg width='20' height='20' viewBox='0 0 24 24' fill='none' stroke={i === cur ? '#9ECC3B' : '#808080'} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'><path d={this.stepIcon(s)} /></svg>
              <div className='rb-step-text'>
                <span>{this.stepText(s)}</span>
                <small>{s.type === 'waypoint' || s.type === 'arrive' || s.type === 'depart' ? `Waypoint ${s.type === 'depart' ? 1 : s.type === 'arrive' ? this.state.waypoints.length : s.waypointNumber}` : (LAYER_LABELS[s.layer] || '').replace(/^the /, '')}</small>
              </div>
              {s.distanceMeters > 0 && <span className='rb-step-dist'>{this.stepDist(s.distanceMeters)}</span>}
            </div>
          ))}
        </div>
      </>
    )
  }

  coordsAfter(m) {
    const { coords } = this.state
    let cum = 0
    for (let i = 1; i < coords.length; i++) {
      cum += segmentDistanceMeters(coords[i - 1], coords[i])
      if (cum >= m) return coords.slice(i - 1)
    }
    return []
  }

  // Short distances read better in ft/m than as 0.0x mi/km.
  stepDist(meters) {
    if (this.props.units === 'imperial') {
      const miles = meters * 0.000621371
      return miles < 0.1 ? `${Math.round(meters * 3.28084 / 10) * 10} ft` : `${miles.toFixed(1)} mi`
    }
    return meters < 1000 ? `${Math.round(meters)} m` : `${(meters / 1000).toFixed(1)} km`
  }

  renderFooter() {
    const { screen, saving } = this.state
    const btn = (label, onClick, cls = '', disabled = false) => (
      <div className={`rb-btn ${cls}${disabled ? ' rb-btn-off' : ''}`} onClick={disabled ? undefined : onClick}>{label}</div>
    )
    if (screen === 'build') return [btn('CANCEL', this.askCancelBuild, 'rb-btn-grey'), btn(saving ? 'SAVING…' : 'SAVE', this.save, 'rb-btn-green rb-btn-wide', !this.canSave())]
    if (screen === 'edit') return [btn('CANCEL', this.cancelEdit, 'rb-btn-grey'), btn(saving ? 'SAVING…' : 'SAVE', this.save, 'rb-btn-green rb-btn-wide', !this.canSave())]
    if (screen === 'view') return [btn('DELETE', () => this.setState({ dialog: 'delete' }), 'rb-btn-grey'), btn('NAVIGATE', this.goNav, 'rb-btn-dark'), btn('EDIT ROUTE', this.goEdit, 'rb-btn-green')]
    const last = this.state.navStep >= this.navSteps().length - 1
    return [btn('END', () => this.setState({ screen: 'view', navStep: 0 }), 'rb-btn-grey'), btn(last ? 'FINISH' : 'NEXT STEP', this.nextStep, 'rb-btn-green rb-btn-wide')]
  }

  // ---------- map overlays (portal into the map container) ----------

  renderAddBar() {
    const { arm, waypoints, query, searchOpen, predictions, undo } = this.state
    const n = waypoints.length
    const full = n >= MAX_ROUTE_WAYPOINTS
    const target = n === 0 ? 'destination' : n === 1 ? 'start' : 'waypoint'
    return (
      <div className='rb-addbar-wrap'>
        <div className={`rb-addbar${arm ? ' rb-addbar-armed' : ''}`}>
          {arm && <XIcon onClick={() => this.setState({ arm: false, searchOpen: false })} />}
          {arm && (
            <input className='rb-search' value={query} autoFocus placeholder={`Search for a ${target}`}
              onChange={e => this.onQuery(e.target.value)}
              onFocus={() => this.setState({ searchOpen: true })}
              onBlur={() => setTimeout(() => this.setState({ searchOpen: false }), 160)} />
          )}
          {arm && query && <XIcon size={14} onClick={() => this.setState({ query: '', predictions: [], searchOpen: false })} />}
          {!arm && undo.length > 0 && (
            <div className='rb-iconbtn' title='Undo' onClick={this.undo}>
              <svg width='15' height='15' viewBox='0 0 24 24' fill='none' stroke='#e8e8e8' strokeWidth='1.9' strokeLinecap='round' strokeLinejoin='round'><path d='M4 9h10a5 5 0 0 1 0 10H8' /><path d='M4 9l4-4M4 9l4 4' /></svg>
            </div>
          )}
          {arm && n === 1 && (
            <div className='rb-locbtn' onClick={this.useMyLocation}>
              <svg width='13' height='13' viewBox='0 0 24 24' fill='none' stroke='#9ECC3B' strokeWidth='1.9' strokeLinecap='round'><circle cx='12' cy='12' r='4' /><path d='M12 2v3M12 19v3M2 12h3M19 12h3' /></svg>
              <span>MY LOCATION</span>
            </div>
          )}
          {arm && !query && <span className='rb-armed-hint'>or click the map</span>}
          {!arm && (
            <div className={`rb-dropbtn${full ? ' rb-btn-off' : ''}`} onClick={full ? undefined : () => this.setState({ arm: true, sel: null })}>
              <svg width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='#fff' strokeWidth='1.9'><path d={PIN_ICON} /><circle cx='12' cy='10' r='2.4' /></svg>
              <span>{n === 0 ? 'ADD DESTINATION' : n === 1 ? 'ADD START' : 'ADD WAYPOINT'}</span>
            </div>
          )}
        </div>
        {arm && searchOpen && query.trim().length >= 2 && (
          <div className='rb-search-results'>
            {predictions.map(p => (
              <div key={p.place_id} className='rb-search-row' onMouseDown={e => e.preventDefault()} onClick={() => this.pickPlace(p)}>
                <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='#9ECC3B' strokeWidth='1.9' style={{ flexShrink: 0 }}><path d={PIN_ICON} /><circle cx='12' cy='10' r='2.4' /></svg>
                <div className='rb-search-text'>
                  <span>{(p.structured_formatting && p.structured_formatting.main_text) || p.description}</span>
                  <small>{p.structured_formatting && p.structured_formatting.secondary_text}</small>
                </div>
                {p.distance_meters != null && <span className='rb-search-away'>{this.dist(p.distance_meters)} {distanceUnit(this.props.units)}</span>}
              </div>
            ))}
            {predictions.length === 0 && <div className='rb-search-empty'>No matches. Try a lake, trailhead, or town.</div>}
          </div>
        )}
      </div>
    )
  }

  renderOverlays(st) {
    const { screen, waypoints, mode, follows, routing, routeMsg, toast, overlayLeft, navStep } = this.state
    const { units } = this.props
    const editing = screen === 'build' || screen === 'edit'
    const hasRoute = waypoints.length >= 2
    const opts = FOLLOW_OPTS.filter(o => !o.hikeOnly || mode === 'hike')
    const pill = toast || (routing ? 'Finding the best route…' : editing ? routeMsg : null)
    let navBanner = null
    if (screen === 'nav') {
      const steps = this.navSteps()
      const cur = Math.min(navStep, steps.length - 1)
      const s = steps[cur]
      navBanner = s && (
        <div className='rb-nav-banner'>
          <svg width='34' height='34' viewBox='0 0 24 24' fill='none' stroke='#9ECC3B' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'><path d={this.stepIcon(s)} /></svg>
          <div className='rb-nav-banner-text'>
            <span>{this.stepText(s)}</span>
            <small>Step {cur + 1} of {steps.length}</small>
          </div>
          {s.distanceMeters > 0 && (
            <div className='rb-nav-banner-dist'><span>{this.stepDist(s.distanceMeters)}</span><small>To next</small></div>
          )}
        </div>
      )
    }
    return (
      <div className='rb-overlays' style={{ left: overlayLeft }}>
        {screen === 'build' && this.renderAddBar()}
        {editing && hasRoute && (
          <div className='rb-mapstats'>
            <div><b>{this.dist(st.distanceMeters)}<small>{distanceUnit(units)}</small></b><span>Distance</span></div>
            <i />
            <div><b>{formatRouteDuration(st.estimatedSeconds)}</b><span>Est Time</span></div>
            <i />
            <div><b className='rb-green'>+{this.elev(st.gainMeters)}<small>{elevUnit(units)}</small></b><span>Elev Gain</span></div>
            <i />
            <div><b>{waypoints.length}</b><span>Waypoints</span></div>
          </div>
        )}
        {pill && <div className='rb-pill'>{pill}</div>}
        {editing && hasRoute && (
          <div className='rb-follows'>
            <div className='rb-follows-legend'>
              {opts.map(o => (
                <svg key={o.key} width='46' height='8' viewBox='0 0 46 8' style={{ opacity: followOn(follows, o.key) ? 1 : 0.35 }}>
                  <line x1='1' y1='4' x2='45' y2='4' stroke={o.under} strokeWidth={o.underW} strokeLinecap='butt' />
                  <line x1='1' y1='4' x2='45' y2='4' stroke={o.stroke} strokeWidth={o.strokeW} strokeDasharray={o.dash} strokeLinecap={o.cap} />
                </svg>
              ))}
            </div>
            <div className='rb-follows-card'>
              <span className='rb-eyebrow'>ROUTE PREFERS</span>
              {opts.map(o => {
                const on = followOn(follows, o.key)
                return (
                  <div key={o.key} className='rb-follow-row' onClick={() => this.toggleFollow(o.key)}>
                    <div className={`rb-check${on ? ' rb-on' : ''}`}>
                      <svg width='9' height='9' viewBox='0 0 24 24' fill='none' stroke='#e8e8e8' strokeWidth='3.4' strokeLinecap='round' strokeLinejoin='round' style={{ opacity: on ? 1 : 0 }}><path d='M5 12.5l4.5 4.5L19 7' /></svg>
                    </div>
                    <span style={{ color: on ? '#e8e8e8' : '#7a7a7a' }}>{mode === 'drive' && o.driveLabel ? o.driveLabel : o.label}</span>
                  </div>
                )
              })}
            </div>
          </div>
        )}
        {navBanner}
      </div>
    )
  }

  renderDialog() {
    const { dialog, name, waypoints } = this.state
    if (!dialog) return null
    const st = this.stats()
    const wrap = (body) => ReactDOM.createPortal(
      <div className='rb-modal-backdrop' onClick={() => this.setState({ dialog: null })}>
        <div className='rb-modal' onClick={e => e.stopPropagation()}>{body}</div>
      </div>, document.body)
    const btn = (label, onClick, cls) => <div className={`rb-modal-btn ${cls || ''}`} onClick={onClick}>{label}</div>
    if (dialog === 'save') {
      return wrap(<>
        <div className='rb-modal-title'>Save "{name}"?</div>
        <div className='rb-modal-body'>{this.dist(st.distanceMeters)} {distanceUnit(this.props.units)} · {waypoints.length} waypoints · {formatRouteDuration(st.estimatedSeconds)}</div>
        <div className='rb-modal-btns'>{btn('DISCARD', this.close)}{btn('SAVE ROUTE', this.save, 'rb-modal-green')}</div>
      </>)
    }
    if (dialog === 'discard') {
      return wrap(<>
        <div className='rb-modal-title'>Discard this route?</div>
        <div className='rb-modal-body'>Your waypoint will be removed.</div>
        <div className='rb-modal-btns'>{btn('KEEP EDITING', () => this.setState({ dialog: null }))}{btn('DISCARD', this.close, 'rb-modal-red')}</div>
      </>)
    }
    if (dialog === 'delete') {
      return wrap(<>
        <div className='rb-modal-title'>Delete this route?</div>
        <div className='rb-modal-body'>"{name}" and its waypoints will be permanently removed. This can't be undone.</div>
        <div className='rb-modal-btns'>{btn('CANCEL', () => this.setState({ dialog: null }))}{btn(this.state.saving ? 'DELETING…' : 'DELETE', this.doDelete, 'rb-modal-red')}</div>
      </>)
    }
    return wrap(<>
      <ProBadge />
      <div className='rb-modal-title' style={{ marginTop: 12 }}>Route Builder is a Pro feature</div>
      <div className='rb-modal-body'>{UPSELL_BODY}</div>
      <div className='rb-modal-btns'>
        {btn('NOT NOW', () => this.setState({ dialog: null }))}
        {btn('UPGRADE TO PRO', this.upgrade, 'rb-modal-green rb-btn-wide')}
      </div>
    </>)
  }

  upgrade() {
    this.setState({ dialog: null })
    this.props.showSubscriptionModal()
  }

  renderGate() {
    return (
      <div className='route-builder-container' ref={this.rootRef}>
        <div className='rb-panel-head'>
          <div className='rb-panel-title'>CREATE ROUTE</div>
          <XIcon size={18} color='#fff' onClick={this.close} />
        </div>
        <div className='rb-panel-scroll'>
          <div className='rb-gate'>
            <ProBadge />
            <div className='rb-gate-title'>Route Builder is a Pro feature</div>
            <div className='rb-gate-body'>{UPSELL_BODY}</div>
          </div>
        </div>
        <div className='rb-footer'>
          <div className='rb-btn rb-btn-grey' onClick={this.close}>NOT NOW</div>
          <div className='rb-btn rb-btn-green rb-btn-wide' onClick={this.upgrade}>UPGRADE TO PRO</div>
        </div>
      </div>
    )
  }

  render() {
    if (this.gated()) return this.renderGate()
    const { screen, coords, waypoints, saveError } = this.state
    const profile = coords.length >= 2 ? buildRouteProfile(coords) : null
    const dists = waypointDistances(waypoints, coords)
    const st = this.stats()
    const title = { build: 'CREATE ROUTE', view: 'ROUTE DETAILS', edit: 'EDIT ROUTE', nav: 'NAVIGATING' }[screen]

    return (
      <div className='route-builder-container' ref={this.rootRef}>
        <div className='rb-panel-head'>
          <div className='rb-panel-title'>{title}</div>
          <XIcon size={18} color='#fff' onClick={this.onClosePanel} />
        </div>
        <div className='rb-panel-scroll'>
          {screen === 'build' && this.renderBuildPanel(profile, dists)}
          {screen === 'edit' && this.renderEditPanel(profile, dists)}
          {screen === 'view' && this.renderViewPanel(profile, dists, st)}
          {screen === 'nav' && this.renderNavPanel(st)}
        </div>
        {saveError && <div className='rb-error'>{saveError}</div>}
        <div className='rb-footer'>{this.renderFooter().map((b, i) => React.cloneElement(b, { key: i }))}</div>
        {this.overlayHost && ReactDOM.createPortal(this.renderOverlays(st), this.overlayHost)}
        {this.renderDialog()}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  token: state.auth.token,
  user: state.user,
  routes: state.routes,
  units: state.userPreferences.units,
  mapReference: typeof state.mapReference === 'function' ? state.mapReference() : null
})

const mapDispatchToProps = dispatch => ({
  blockFeatures: () => dispatch(blockFeatures()),
  unBlockFeatures: () => dispatch(unBlockFeatures()),
  routeCreateRequest: obj => dispatch(routeCreateRequest(obj)),
  routeUpdateRequest: obj => dispatch(routeUpdateRequest(obj)),
  routeDeleteRequest: id => dispatch(routeDeleteRequest(id)),
  expandLeftToolbar: payload => dispatch(expandLeftToolbar(payload)),
  showSubscriptionModal: () => dispatch(showSubscriptionModal()),
  photoUploadRequest: data => dispatch(photoUploadRequest(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(RouteBuilder)
